/* Built In Imports */

/* Internal Imports */
/* Components */
import config from '@config';
// import { tryGetPreviewData } from 'utils';

/* Services */
import { filterBuildUrls } from 'services/commonService';
import { IsoBackendHttpService } from 'utils/IsoBackendHttpService';
import { getLatestBuild } from './commonService';

let isCache = false;
const API_PREFIX = '/content/fetchiso';

export const fetchExclusivePageData = async (region, lang, slug = ``) => {
  const pageData = await new IsoBackendHttpService().get(
    `${API_PREFIX}/content`,
    !isCache,
    {
      params: {
        format: 'json',
        slug: slug ? `${slug}` : `sadhguru-exclusive`,
        region,
        lang,
      },
    }
  );
  return pageData;
};
export const getExclusiveLandingPaths = async (level, url, notMatchText) => {
  let data = {};
  if (process.env?.NEXT_PUBLIC_BUILD_ID) {
    data = await getLatestBuild(process.env.NEXT_PUBLIC_BUILD_ID);
  } else if (config.BUILD_URLS?.LANDING_PAGES?.SadhguruExclusive) {
    data = await getLatestBuild(
      process.env.NEXT_PUBLIC_BUILD_ID || process.env.env_var_build_id
    );
  }
  let urlArr = filterBuildUrls('landing_pages', level, url, notMatchText, data);
  return urlArr || [];
};

/**
 *
 * @param region
 * @param language
 */
export async function fetchPackageData(region, language) {
  let countryCode = '';
  if (region !== 'global') {
    countryCode = region.toUpperCase();
  } else {
    countryCode = language.toUpperCase();
  }
  // const res = await fetch(
  //   `https://iso-facade.sadhguru.org/content/exclusive-fetchpackage`
  // );
  let url = `${config.FACADE_BASE_PATH}/content/exclusive-fetchpackage`;
  const res = await fetch(url);
  const PackageData = await res.json();
  return PackageData;
}

export const fetchExclusiveRenewPageData = async (region, lang) => {
  const pageData = await new IsoBackendHttpService().get(
    `${API_PREFIX}/content`,
    !isCache,
    {
      params: {
        format: 'json',
        slug: `sadhguru-exclusive/renew`,
        region,
        lang,
      },
    }
  );
  return pageData;
};

export const fetchExclusiveEventPageData = async (region, lang) => {
  const pageData = await new IsoBackendHttpService().get(
    `${API_PREFIX}/content`,
    !isCache,
    {
      params: {
        format: 'json',
        slug: `sadhguru-exclusive/kailash-yatra-live`,
        region,
        lang,
      },
    }
  );
  return pageData;
};

export const getExclusiveEventPaths = async (level, url, notMatchText) => {
  let data = {};
  if (process.env?.NEXT_PUBLIC_BUILD_ID) {
    data = await getLatestBuild(process.env.NEXT_PUBLIC_BUILD_ID);
  } else if (config.BUILD_URLS?.LANDING_PAGES?.SadhguruExclusiveEvent) {
    data = await getLatestBuild(
      process.env.NEXT_PUBLIC_BUILD_ID || process.env.env_var_build_id
    );
  }
  let urlArr = filterBuildUrls('landing_page', level, url, notMatchText, data);
  return urlArr || [];
};

export const fetchExclusiveFaintPageData = async (region, lang) => {
  const pageData = await new IsoBackendHttpService().get(
    `${API_PREFIX}/content`,
    !isCache,
    {
      params: {
        format: 'json',
        slug: `sadhguru-exclusive/not-for-the-faint-hearted`,
        region,
        lang,
      },
    }
  );
  return pageData;
};

export const fetchExclusivePromoPageData = async (region, lang) => {
  const pageData = await new IsoBackendHttpService().get(
    `${API_PREFIX}/content`,
    !isCache,
    {
      params: {
        format: 'json',
        slug: `sadhguru-exclusive/free-trial`,
        region,
        lang,
      },
    }
  );
  return pageData;
};

export const fetchTrendingData = async (region, language) => {
  let url = '';
  if (config.ENV_NAME === 'production') {
    url = `https://sgexclusive.sadhguru.org/video/getSeriesList/non_logged_in?sort_by=week_popular&limit=5&ignore_progress=1`;
  } else {
    url = `https://uat-facade-sgexclusive.sadhguru.org/video/getSeriesList/non_logged_in?sort_by=week_popular&limit=5&ignore_progress=1`;
  }
  const res = await fetch(url);
  const trendingData = await res.json();
  return trendingData;
};
